import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from './Link';
import Teaser from './Teaser';
import Carousel from './Carousel';

import '../../styles.css';

BRichContents.propTypes = {
  className: PropTypes.string, // necessaire pour styled
  richContents: PropTypes.arrayOf(PropTypes.object),
};

/**
 * RichContents display one or several elements, depending on contents and expand mode
 *
 * * si ce sont que des liens (aucun objet n'a de description ni d'image) => lien simple, ou liste de liens
 * * si au moins 1 teaser => teaser simple, ou liste de teasers
 *     * default : les uns en dessous des autres
 *     * mid : 2 par 2 (flex, meme hauteur) - largeur max centré
 *     * full : 3 par 3 (flex, meme hauteur) - largeur max centré
 *
 * * autre possibilite, mise de cote pour le moment : slider
 *
 * @param {*} param0
 * @returns
 */
function BRichContents({className,richContents}) {

  if (!richContents || richContents.length === 0) {
    return null;
  }

  function asTeaser(richContent) {
    if (richContent && (richContent.description !== undefined || richContent.image !== undefined ))
      return true;
    return false;
  }

  // si y'en a qu'un
  if (richContents.length === 1) {
    const richContent = richContents[0];
    if (!richContent)
      return null;
    if (asTeaser(richContent)) {
      return <RichContentSingleTeaser richContent={richContent} />;
    }
    return <RichContentSingleLink richContent={richContent} />;
  }

  let onlyLinks = true;
  richContents.forEach((richContent) => {
    if (asTeaser(richContent)) {
      onlyLinks = false;
    }
  });

  // si que des liens, liste de liens
  if (onlyLinks)
    return <RichContentLinksList richContents={richContents} />;

  // sinon, teasers (meme si y'a des liens) sous forme de grid
  // NB : on pourrait aussi mettre un Carousel, c'est un choix
  // il faudrait avoir une props indiquant le mode :
  //   * default / mobile => carousel
  //   * desktop + mid ou full => grid
  return <RichContentTeasersGrid richContents={richContents} />;
  // return <RichContentTeasersCarousel richContents={richContents} />;
}

const RichContents = styled(BRichContents)`
  &.richcontent-multiple-teasers {
    .richcontent + .richcontent {
      margin-top: 1em;
    }
  }
`;

export default RichContents;





function BRichContentSingleTeaser({className,richContent}) {
  if (!richContent)
    return null;

  return (
    <div className={className + '  richcontents-single-teaser'}>
      <div className={'richcontent-teaser'}>
        <Teaser title={richContent.title} target={richContent.target} text={richContent.description} image={richContent.image}/>
      </div>
    </div>
  );
}
const RichContentSingleTeaser = styled(BRichContentSingleTeaser)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .richcontent-teaser {
    max-width: 207px;  /* 1 seul mais pas trop gros */
  }
`;

function BRichContentSingleLink({className,richContent}) {
  if (!richContent)
    return null;

  return (
    <div className={className + '  richcontents-single-link'}>
      <Link title={richContent.title} target={richContent.target} />
    </div>
  );
}
const RichContentSingleLink = styled(BRichContentSingleLink)`
`;

function BRichContentLinksList({className,richContents}) {
  if (!richContents || richContents.length === 0)
    return null;

  return (
    <div className={className + '  richcontents-linkslist'}>
      {richContents.map((richContent,index) => {
        return (
          <div key={index} className={'richcontent-link'}>
            <Link key={index} title={richContent.title} target={richContent.target} />
          </div>
        );
      })}
    </div>
  );
}
const RichContentLinksList = styled(BRichContentLinksList)`
  .richcontent-link {
    margin-left: 2rem;
    position: relative;
    &:before{
      content: '';
      display: block;
      position: absolute;
      top: 4px;
      left: -4px;
      with: 4px;
      height: 4px;
      border-radius: 50%;
      background: #FFF;
    }
  }
`;

function BRichContentTeasersGrid({className,richContents}) {
  if (!richContents || richContents.length === 0)
    return null;

  return (
    <div className={className + '  richcontents-teasers-grid'}>
      {richContents.map((richContent,index) => {
        return (
          <div key={index} className={'richcontent-teaser'}>
            <Teaser title={richContent.title} target={richContent.target} text={richContent.description} image={richContent.image}/>
          </div>
        );
      })}
    </div>
  );
}
// en mobile, block, tout en 100% les uns sous les autres
// en desktop, si mode default, block, tout en 100% les uns sous les autres
// en desktop, si mode mid, flex centered, 2 par 2
// en desktop, si mode full, mais ecran <780, idem que mid
// en desktop, si mode full, mais ecran >780, flex centered, 3 par 3
// CF styles.css
const RichContentTeasersGrid = styled(BRichContentTeasersGrid)`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  .richcontent-teaser + .richcontent-teaser {
    margin-top: 1rem;
  }
  .richcontent-teaser {
    max-width: 207px;  /* les uns sous les autres mais pas trop gros */
  }
`;


function BRichContentTeasersCarousel({className,richContents}) {
  if (!richContents || richContents.length === 0)
    return null;

  let items = [];
  richContents.forEach((richContent) => {
    const aTeaser = <Teaser title={richContent.title} target={richContent.target} text={richContent.description} image={richContent.image}/>;
    items.push(aTeaser);
  });

  return (
    <div className={className + '  richcontents-teasers-carousel'}>
      <Carousel items={items} />
    </div>
  );
}
const RichContentTeasersCarousel = styled(BRichContentTeasersCarousel)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .carousel {
    max-width: 207px;  /* les uns sous les autres mais pas trop gros, on prend la taille max du mode default */
  }
`;